
import { mapState } from 'vuex'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: { },
data () {
return {
tab: 0,
showDialog: false,
user: {
userId: ''
},
prevImages: [],
previewOptions: {},
info: {
id: '',
title: '',
address: '',
time: '',
img: '',
imgList: [],
fcontent: '',
scontent: '',
url: ''
},
comment: {
page: 1,
limit: 10,
totals: 0,
isLoading: false,
isEnd: false,
list: []
},
leaveWords: ''
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
vm.user = vm.$store.state.sx.user || vm.user
vm.prevImages = []
vm.comment.list = []
vm.$post('article/detail', {
id: to.params.id,
type: '100',
userId: vm.user.userId
}, (res) => {
if (res.code === 200) {
for (let item in res.data) {
if (res.data[item] !== undefined && res.data[item] !== null) {
vm.info[item] = res.data[item]
}
}
for (let img in vm.info.imgList) {
vm.prevImages.push({
msrc: vm.info.imgList[img],
src: vm.info.imgList[img]
})
}
if (vm.$isWechat()) {
let shareLink = window.location.href
let shareDesc = vm.info.address + ' ' + vm.info.time
let shareImage = vm.info.img
if (!shareImage && vm.info.imgList && vm.info.imgList.length) {
shareImage = vm.info.imgList[0]
}
vm.$wechatShare(shareLink, shareLink, vm.info.title, shareDesc, shareImage)
}
}
})
})
},
computed: {
...mapState({
scrollBottom: state => state.sx.scrollBottom
}),
loadingTip () {
if (this.comment.isLoading) {
return '正在加载'
} else if (this.comment.isEnd) {
return this.comment.list.length ? '没有更多了' : '暂无内容'
} else {
return ''
}
}
},
methods: {
preview (index) {
this.$refs.prevImage.show(index)
},
viewOriginal () {
if (this.info.url) {
document.location.href = this.info.url
}
},
subscribe () {
this.$post('article/subscribe', {
id: this.info.id,
userId: this.user.userId
}, (res) => {
if (res.code === 200) {
this.$vux.toast.show({
text: '关注成功'
})
} else if (res.code === 300) {
this.showDialog = true
} else if (res.code === 400) {
this.$vux.toast.show({
type: 'text',
width: '10em',
text: '您已经关注过啦'
})
} else {
this.$vux.toast.show({
type: 'text',
width: '12em',
text: res.msg
})
}
})
},
getComments (reload) {
if (reload) {
this.comment.list = []
this.comment.page = 1
this.comment.totals = 0
this.comment.isLoading = false
this.comment.isEnd = false
}
this.$post('comment/list', {
id: this.info.id,
type: '100',
page: this.comment.page,
limit: this.comment.limit
}, (res) => {
if (res.code === 200) {
this.comment.totals = res.data.totals
if (res.data.list.length < this.comment.limit) {
this.comment.isEnd = true
}
this.comment.list = this.comment.list.concat(res.data.list)
}
})
},

submitLeaveWords () {
let vm = this
if (vm.leaveWords.length) {
vm.$post('comment/save', {
id: vm.info.id,
userId: vm.user.userId,
text: vm.leaveWords
}, (res) => {
if (res.code === 200) {
vm.leaveWords = ''
vm.$vux.toast.show({
text: '留言发送成功',
onHide () {
vm.getComments(true)
}
})
} else if (res.code === 300) {
vm.showDialog = true
} else if (res.code === 400) {
vm.$vux.toast.show({
type: 'text',
width: '12em',
text: '您的留言存在敏感内容，请重新编辑。'
})
}
})
}
}
},
watch: {
tab (value) {
if (value === 2) {
if (this.comment.list.length === 0) {
this.getComments(true)
}
}
},
scrollBottom (isBottom) {
if (isBottom && this.$route.name === 'MeetingView' && this.tab === 2 &&
!this.comment.isLoading && !this.comment.isEnd) {
this.comment.page ++
this.getComments()
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/MeetingView.vue